<template>
  <v-dialog
    v-model="showModal"
    persistent
    width="700px"
  >
    <v-card
      elevation="0"
      color="#ffff"
    >
      <v-card-title>
        <p class="process-header">
          Confirm Same Checkin
        </p>
      </v-card-title>
      <v-card-text class="justify-center">
        <v-card-text>
          <p class="title-text-style">
            Project: <font class="value-text-style">
              {{ previousCheckInDetails.project.name }}
            </font>
          </p>
          <p class="title-text-style">
            Name: <font
              v-if="previousCheckInDetails.work_details.type === 'project-work'"
              class="value-text-style"
            >
              {{ previousCheckInDetails.work_details.budget.name }}
            </font>
            <font
              v-else
              class="value-text-style"
            >
              {{ previousCheckInDetails.work_details.issue.name }}
            </font>
          </p>
          <p class="title-text-style">
            Type: <font class="value-text-style">
              {{ previousCheckInDetails.work_details.type | workTypeFormat }}
            </font>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer /><v-btn
            class="next-style"
            elevation="0"
            @click="checkIn"
          >
            CheckIn
          </v-btn>
          <v-btn
            class="cancel-style"
            elevation="0"
            @click="showModal = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
    <centre-spinner :loading="loading" />
  </v-dialog>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';
import moment from 'moment';
export default {
  name: 'IssueStatus',
  components: {
    'centre-spinner': spinner,
  },
    filters: {
      displayHighRisk (status) {
        if (status === true) {
          return 'Yes*';
        } else {
          return 'No';
        }
      },
      workTypeFormat (val) {
        if (val === 'project-work') {
          return 'Project Work';
        } else {
          return 'Project Issue';
        }
      },
    },
  data: () => ({
    loading: false,
    valid: false,
    showModal: true,
  }),
  computed: {
    checkOutType () {
      return this.$store.getters['devices/getCheckOutType'];
      },
    previousCheckInDetails () {
        return this.$store.getters['devices/getPreviousCheckInDetails'];
      },
      deviceData () {
      return this.$store.getters.getDeviceData;
    },
    checkInId () {
        return this.$store.getters['devices/getCheckInId'];
      },

    },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  async mounted () {
    // await this.getPreviousCheckInDetails();
  },
    methods: {
      async checkIn () {
        this.loading = true;
        await this.$store.dispatch('devices/checkInUser', {
          orgExtId: this.deviceData.organization_id.external_id,
        details: {
          checkin_time: moment.utc().format(),
          type: 'worker',
          checkin_method_type: 'manual-checkin',
          project_id: this.previousCheckInDetails.project.id,
          kiosk_id: this.deviceData.id,
        },
        }).then(response => {
          this.sendWorkDetails();
          this.loading = false;
        }).catch(errors => {
          this.loading = false;
        });
      },
       async sendWorkDetails () {
        if (this.previousCheckInDetails.work_details.type === 'project-work') {
          await this.$store.dispatch('devices/sendWorkDetails', {
            details: {
              budget_id: this.previousCheckInDetails.work_details.budget.id,
              budget_instance_id: this.previousCheckInDetails.work_details.instance === null ? null : this.previousCheckInDetails.work_details.instance.id,
              issue_id: null,
              type: 'project-work',
            },
            checkInId: this.checkInId.id,
          }).then(response => {
            this.loading = false;
            this.$store.dispatch('alert/onAlert', {
              message: 'Check-in completed successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.$store.dispatch('devices/workerLogout');
            this.$store.dispatch('kioskUserLogout');
            this.loading = false;
            this.$router.push({ name: 'DeviceCheckInCheckOut' });
          }).catch(() => {
            this.loading = false;
          });
        return;
        }
        await this.$store.dispatch('devices/sendWorkDetails', {
          details: {
            budget_id: null,
            budget_instance_id: null,
            issue_id: this.previousCheckInDetails.work_details.issue.id,
            type: 'project-issue',
          },
          checkInId: this.checkInId.id,
        }).then(response => {
          this.loading = false;
          this.$store.dispatch('alert/onAlert', {
            message: 'Check-in completed successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.$store.dispatch('devices/workerLogout');
          this.$store.dispatch('kioskUserLogout');
            this.loading = false;
            this.$router.push({ name: 'DeviceCheckInCheckOut' });
        }).catch(() => {
          this.loading = false;
        });
      },
      },
      async getPreviousCheckInDetails () {
        this.loading = true;
        await this.$store.dispatch('devices/fetchPreviousCheckInDetails').catch(() => {
          this.loading = false;
        });
        this.loading = false;
      },
      cancel () {
        this.$emit('closed');
      },
};
</script>

<style scoped>
</style>
